export function sortLicensesAccordingToPricing(licenses, pricing) {
  let sortedLicenses = null;
  if (licenses && Array.isArray(licenses)) {
    sortedLicenses = licenses;
    if (pricing) {
      sortedLicenses = licenses.sort((lic1, lic2) => {
        const lic1Pricing = pricing[lic1.licenseId];
        const lic2Pricing = pricing[lic2.licenseId];

        let comparison = 0;
        const position1 = lic1Pricing.position || 0;
        const position2 = lic2Pricing.position || 0;
        if (position1 !== position2) {
          comparison = position1 - position2;
        } else {
          comparison = lic2.dateCreated - lic1.dateCreated;
        }

        return comparison;
      })
    }
  }

  return sortedLicenses;
}

export function dateFromObjectId(objectId) {
  let timeStamp = 0;
  if (typeof objectId === 'object') {
    timeStamp = objectId.getTimestamp();
  } else if (typeof objectId === 'string') {
    timeStamp = parseInt(objectId.substring(0, 8), 16) * 1000;
  }

  return new Date(timeStamp);
}
